import { useSelector } from 'react-redux';
import ConsentForm from '../../service-steps/pre-assessment/consent-form';
import PreviousHistoryGate from '../../service-steps/pre-assessment/previous-history-gate';

const PreAssessment = () => {  
  const { clinicalServiceObj } = useSelector((state) => state.clinicalService);
  const { currentSubStep } = clinicalServiceObj.initialAssessment.initialAssessmentForm;

    const renderStep = () => {
      const subStep = currentSubStep === 0 ? 1 : currentSubStep;
      switch (subStep) {
        case 1:
          return <ConsentForm />;
        case 2:
          return <PreviousHistoryGate />;
      }
    }
    return renderStep();
}

export default PreAssessment